import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  recentSearch: [],
  recentSearchError: '',
  recentSearchLoading: false,
};

export const recentSearchSlice = createSlice({
  name: "recentSearch",
  initialState,
  reducers: {
    fetchRecentSearch: (state) => {
      state.recentSearchLoading = true;
    },
    fetchRecentSearchSuccess: (state, action) => {
      state.recentSearchLoading = false;
      state.recentSearch = action.payload;
      state.recentSearchError = '';
    },
    fetchRecentSearchFailure: (state, action) => {
      state.recentSearchLoading = false;
      state.recentSearchError = action.payload;
    },
    updateRecentSearch: (state) => {
      state.recentSearchLoading = true;
    },
    updateRecentSearchSuccess: (state) => {
      state.recentSearchLoading = false;
      state.recentSearchError = '';
    },
    updateRecentSearchFailure: (state) => {
      state.recentSearchLoading = false;
      state.recentSearchError = action.payload;
    },
  },
});

export const {
  fetchRecentSearch,
  fetchRecentSearchSuccess,
  fetchRecentSearchFailure,
  updateRecentSearch,
  updateRecentSearchSuccess,
  updateRecentSearchFailure,
} = recentSearchSlice.actions;
export const recentSearchData = (state) => (state.recentSearch)
export default recentSearchSlice.reducer;